module.exports = __webpack_public_path__ + "static/media/YB5F14_4.f96cb224.jpg";